// src/App.js
import React, { useState } from 'react';
import Quiz from './Quiz';
import Results from './Results';
import './App.css';

function App() {
  const [showResults, setShowResults] = useState(false);
  const [score, setScore] = useState(0);
  const [totalQuestions, setTotalQuestions] = useState(0);

  const handleQuizComplete = (finalScore, total) => {
    setScore(finalScore);
    setTotalQuestions(total);
    setShowResults(true);
  };

  const handleRetry = () => {
    setShowResults(false);
    setScore(0);
    setTotalQuestions(0);
  };

  return (
    <div className="App">
      <header className="App-header">
        <h1>Physics Quiz</h1>
      </header>
      {showResults ? (
        <Results score={score} totalQuestions={totalQuestions} onRetry={handleRetry} />
      ) : (
        <Quiz onComplete={handleQuizComplete} />
      )}
    </div>
  );
}

export default App;